import React, { useEffect, useState } from 'react'

export const Sidebar = ({setselectPanel}) => {

  useEffect(() => {

  }, [setselectPanel])
  
  const [ sideSelected, setSideSelected ] = useState(false)
  
  const handleSelected = () => {
    setSideSelected( !sideSelected )
  }

const handlePanel = (e) => {
  setselectPanel(e)
  handleSelected()
}

  return (

<div className={sideSelected? "sidebar active animate__animated animate__fadeInLeft" : "sidebar notActive " } >

    <div className={ sideSelected ? 'button-tgl active-btn': 'button-tgl notActive-btn' }>
        <i
            
            alt="Menú"
            className={
              sideSelected
                ? "fas fa-times burger-nav "
                : "fas fa-bars burger-nav "
            }
            onClick={handleSelected}
        ></i>
    </div>
   
      <h4 className="">AdminPanel</h4>
    
    <ul className="list-unstyled ps-0" >
    <li className="border-top my-2"></li>
    {/* USUARIOS */}
      <li className="mb-1">
        <button 
          className=" btn-toggle align-items-center rounded collapsed" 
          data-bs-toggle="collapse" 
          data-bs-target="#users-collapse " 
          aria-expanded="false"

        >
            Usuarios
        </button>
        <div className="collapse" id="users-collapse" >

          <ul className="nav btn-toggle-nav mb-3 col-12" id="pills-tab" role="tablist">
            <li  role="presentation">
                <div 
                  className=" col-12 active" 
                  id="AllUsers" 
                  href="#allusers" 
                  data-bs-toggle="pill" 
                  data-bs-target="#pills-Usuarios" 
                  type="button" 
                  role="tab" 
                  aria-controls="Users" 
                  aria-selected="true"
                  onClick={()=>handlePanel('user')}
                >
                    Todos
                </div>
            </li>

            <li role="presentation">
                <div 
                  className="col-12" 
                  id="UserAdd" 
                  href="#useradd" 
                  data-bs-toggle="pill" 
                  data-bs-target="#pills-UserAdd" 
                  type="button" 
                  role="tab" 
                  aria-controls="pills-UserAdd" 
                  aria-selected="false"
                  onClick={()=>handlePanel('user')}
                >
                  Crear
                </div>
            </li>

            
          </ul>

        </div>
      </li>
    {/* PRODUCTOS */}
    <li className="mb-1">
        <button 
          className=" btn-toggle align-items-center rounded collapsed" 
          data-bs-toggle="collapse" 
          data-bs-target="#products-collapse " 
          aria-expanded="false"

        >
            Productos
        </button>
        <div className="collapse" id="products-collapse" >

          <ul className="nav btn-toggle-nav mb-3 col-12" id="pills-tab" role="tablist">
            <li  role="presentation">
                <div 
                  className=" col-12 active" 
                  id="AllProducts" 
                  href="#allproducts" 
                  data-bs-toggle="pill" 
                  data-bs-target="#pills-Products" 
                  type="button" 
                  role="tab" 
                  aria-controls="Products" 
                  aria-selected="true"
                  onClick={()=>handlePanel('product')}
                >
                    Todos
                </div>
            </li>

            <li role="presentation">
                <div 
                  className="col-12" 
                  id="ProductsAdd" 
                  href="#productsadd" 
                  data-bs-toggle="pill" 
                  data-bs-target="#pills-ProductsAdd" 
                  type="button" 
                  role="tab" 
                  aria-controls="pills-ProductsAdd" 
                  aria-selected="false"
                  onClick={()=>handlePanel('product')}
                >
                  Agregar
                </div>
            </li>

            
          </ul>

        </div>
      </li>

    {/* PEDIDOS */}
      <li className="mb-1">
        <button 
          className=" btn-toggle align-items-center rounded collapsed" 
          data-bs-toggle="collapse" 
          data-bs-target="#pedidos-collapse " 
          aria-expanded="false"

        >
            Ventas
        </button>
        <div className="collapse" id="pedidos-collapse" >

          <ul className="nav btn-toggle-nav mb-3 col-12" id="pills-tab" role="tablist">
            <li  role="presentation">
                <div 
                  className=" col-12 active" 
                  id="Encargos" 
                  href="#encargos" 
                  data-bs-toggle="pill" 
                  data-bs-target="#pills-Encargos" 
                  type="button" 
                  role="tab" 
                  aria-controls="Encargos" 
                  aria-selected="true"
                  onClick={()=>handlePanel('pedidos')}
                >
                    Encargos
                </div>
            </li>

            <li role="presentation">
                <div 
                  className="col-12" 
                  id="Entregas" 
                  href="#entregas" 
                  data-bs-toggle="pill" 
                  data-bs-target="#pills-Entregas" 
                  type="button" 
                  role="tab" 
                  aria-controls="pills-Entregas" 
                  aria-selected="false"
                  onClick={()=>handlePanel('pedidos')}
                >
                  Entregas
                </div>
            </li>
            <li role="presentation">
                <div 
                  className="col-12" 
                  id="StockOff" 
                  href="#stockoff" 
                  data-bs-toggle="pill" 
                  data-bs-target="#pills-Stockoff" 
                  type="button" 
                  role="tab" 
                  aria-controls="pills-Stockoff" 
                  aria-selected="false"
                  onClick={()=>handlePanel('pedidos')}
                >
                  Stock Off
                </div>
            </li>

            
          </ul>

        </div>
      </li>


    </ul>


  </div>


  )
}
